<template>
  <div class="indexBg">
    <div class="header">
      <div class="left">
        <div
          class="return"
          :class="{ active: isReturn }"
          @mousedown="handlePressReturn(true)"
          @mouseup="handlePressReturn(false)"
          @mouseleave="handlePressReturn(false)"
          @touchstart="handlePressReturn(true)"
          @touchend="handlePressReturn(false)"
          @touchcancel="handlePressReturn(false)"
          @click="goReturn"
        ></div>
        <div class="questionsNumber">
          <span>{{ currentQuestionNumber }}</span
          >/{{ totalQuestionNumber }} 题
        </div>
      </div>

      <div class="timeBox">
        <div class="time">{{ formattedTime }}</div>
      </div>
    </div>
    <div class="title"></div>
    <div class="content"></div>
    <div class="footerBtn" @click="goToIndex1">
      继续答题（<span> {{ countdown }}s）</span>
    </div>
  </div>
</template>
<script>
import sceneAudioMixin from "@/mixins/sceneAudio";
import sceneManager from "@/utils/sceneManager";
export default {
  name: "voiceCallPage",
  mixins: [sceneAudioMixin],
  data() {
    return {
      isReturn: false,
      countdown: 5,
      countdownTimer: null,
      currentQuestionNumber: "--",
      totalQuestionNumber: "--",
      startTime: null,
      timer: null,
      lastInteractionTime: null,
      guidanceTimer: null,
      elapsedSeconds: 0,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.elapsedSeconds / 60);
      const seconds = this.elapsedSeconds % 60;
      return `${minutes}分${seconds}秒`;
    },
  },
  created() {
    // 如果从 evaluation.vue 跳转过来，会存在全局开始时间
    const globalStart = window.__evaluationStartTimestamp || Date.now();

    this.startTime = globalStart; // 用全局时间作为起点
    this.lastInteractionTime = Date.now();
    // ✅ 立即计算一次，避免闪现 0分0秒
    this.elapsedSeconds = Math.floor((Date.now() - this.startTime) / 1000);
    this.startTimer();
  },
  mounted() {
    if (
      !sceneManager.hasScenes() ||
      sceneManager.getCurrentIntroRoute() !== "voiceCallIndex"
    ) {
      this.$router.replace("/evaluation");
      return;
    }
    this.updateQuestionProgress();
    this.playSceneAudio("voiceCall", "index", () => {
      this.startCountdown();
    });
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.guidanceTimer) clearTimeout(this.guidanceTimer);
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },

  methods: {
    startTimer() {
      // ✅ 再启动定时器，保持每秒更新
      this.timer = setInterval(() => {
        this.elapsedSeconds = Math.floor((Date.now() - this.startTime) / 1000);
      }, 1000);
    },

    updateInteractionTime() {
      this.lastInteractionTime = Date.now();
      if (this.showGuidance) {
        this.hideGuidance();
      }
      this.startGuidanceTimer();
    },
    handlePressReturn(state) {
      this.isReturn = state;
    },
    updateQuestionProgress() {
      const { current, total } = sceneManager.getQuestionProgress();
      this.currentQuestionNumber = current || "--";
      this.totalQuestionNumber = total || "--";
    },
    goReturn() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否退出本次测评？",
        })
        .then(() => {
          // on confirm
          this.$router.replace("/");
        })
        .catch(() => {
          // on cancel
        });
    },
    startCountdown() {
      console.log(this.countdown, "this.countdown");

      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.goToIndex1();
        }
      }, 1000);
    },
    goToIndex1() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.$router.push({
        name: "voiceCallIndex1",
      });
    },
  },
};
</script>

<style scoped lang="less">
.indexBg {
  //   width: 100%;
  height: 100vh;
  background: url("@/assets/scene/sceneBg.png") no-repeat center / 100% 100%;
}
.header {
  position: absolute;
  top: 20px;
  // left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-family: Alibaba-PuHuiTi-Regular;

  .left {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .return {
      width: 80px;
      height: 80px;
      background: url("@/assets/return.png") no-repeat center / 100% 100%;
      margin-right: 50px;
      // margin-left: 20px;
    }
    .return.active {
      background: url("@/assets/returnOver.png") no-repeat center / 100% 100%;
    }
    .questionsNumber {
      display: flex;
      align-items: flex-end;
      font-size: 43px;
      color: #fff;
      span {
        color: #fbf741;
      }
    }
  }

  .timeBox {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-radius: 50px;
    border-radius: 67.5px;
    background: rgba(255, 255, 255, 1);
    opacity: 0.8;
    color: #326edc;
    font-size: 43px;
    margin-right: 20px;
    // .timeIcon {
    //   width: 50px;
    //   height: 50px;
    //   background: url("@/assets/time.png") no-repeat center / 100% 100%;
    //   margin-right: 30px;
    // }
  }
}
.title {
  position: absolute;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  width: 383px;
  height: 60px;
  background: url("@/assets/scene/sceneTitle.png") no-repeat center / 100% 100%;
}
.content {
  position: absolute;
  top: 260px;
  left: 50%;
  transform: translateX(-50%);
  width: 660px;
  height: 725px;
  background: url("@/assets/scene/voiceCall.png") no-repeat center / 100% 100%;
}
.footerBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1060px;
  left: 50%;
  transform: translateX(-50%);
  width: 318px;
  height: 80px;
  font-size: 35px;
  font-family: Alibaba-PuHuiTi-Bold;
  font-weight: 500;
  color: #fff;
  background: url("@/assets/scene/continue.png") no-repeat center / 100% 100%;
  cursor: pointer;
  transition: opacity 0.3s;

  &:active {
    opacity: 0.7;
  }
}
</style>
